export const appConfig = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL as string
};